import { useEffect, useRef, useState } from "react";
import DatePicker from "react-datepicker";
import Loader from "./Loader";
import { Autocomplete, useJsApiLoader } from "@react-google-maps/api";
import {
  auth,
  db,
  onAuthStateChanged,
  storage,
} from "../utilities/firebaseConfig";
import {
  ref as storageRef,
  uploadBytes,
  getDownloadURL,
} from "firebase/storage";
import { get, push, ref, set } from "firebase/database";
import { getAuth, signOut } from "firebase/auth";
import { Navigate, useNavigate } from "react-router-dom";
import moment from "moment";

const libraries = ["places"];
function TechnicianVeri({ isOpen, children, onClose }) {
  const [active, setActive] = useState("techtitledescription");
  const [mobile, setMobile] = useState("");
  const [gender, setGender] = useState("");
  const [govissuedid, setGovIssuedId] = useState("");
  const [showGender, setShowGender] = useState(false);
  const [showgovid, setShowgovid] = useState(false);
  const [date, setDate] = useState(null);
  const [issuingDate, setIssuingDate] = useState(null);
  const [address, setAddress] = useState("");
  const [loading, setLoading] = useState(false);
  const [autocomplete, setAutocomplete] = useState(null);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedServices, setSelectedServices] = useState([]);
  const [services, setServices] = useState([]);
  const [categories, setCategories] = useState({});
  const [expyears, setExpyears] = useState("");
  const [certificateName, setCertificateName] = useState("");
  const [issuingOrganisation, setIssuingOrganisation] = useState("");
  const [certificateFile, setCertificateFile] = useState(null);
  const [govisFile, setGovisFile] = useState(null);
  const [profileFile, setProfileFile] = useState(null);
  const [addressfile, setAddressFile] = useState(null);
  const [selecttday, setSelecttday] = useState("");
  const [aboutme, setAboutme] = useState("");
  const [time, setTime] = useState("");
  const navigate = useNavigate();
  const [userData, setUserData] = useState(null);

  const googleMapsApiKey = "AIzaSyCq1eeQipLUK-43-lJPCGWIZAVzJuuhWpY";
  useEffect(() => {
    const fetchUserData = async () => {
      setLoading(true);
      const user = auth.currentUser;
      if (!user) {
        console.error("No authenticated user found.");
        setLoading(false);
        navigate("/login");
        return;
      }

      try {
        const userRef = ref(db, `technicians/${user.uid}`);
        const snapshot = await get(userRef);
        if (snapshot.exists()) {
          setUserData(snapshot.val());
        } else {
          console.error("User data not found.");
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
      setLoading(false);
    };

    fetchUserData();
  }, []);

  const didLoadData = useRef(false);

  // ✅ 1. Load from localStorage once on mount
  useEffect(() => {
    const storedData = JSON.parse(localStorage.getItem("technicianFormData"));
    if (storedData) {
      setMobile(storedData.mobile || "");
      setGender(storedData.gender || "");
      setDate(storedData.date ? moment(storedData.date) : null);
      setAddress(storedData.address || "");
      setSelectedCategory(storedData.selectedCategory || "");
      setSelectedServices(storedData.selectedServices || []);
      setExpyears(storedData.expyears || "");
      setCertificateName(storedData.certificateName || "");
      setIssuingOrganisation(storedData.issuingOrganisation || "");

      setIssuingDate(storedData.issuingDate || null);
      setCertificateFile(storedData.certificateFile || null);
      setGovIssuedId(storedData.govissuedid || "");
      setGovisFile(storedData.govisFile || null);
      setAddressFile(storedData.addressfile || null);
      setProfileFile(storedData.profileFile || null);
      setAboutme(storedData.aboutme || "");
    }
    // ✅ Mark as loaded after restoring
    didLoadData.current = true;
  }, []);

  useEffect(() => {
    // ⛔ Skip saving on the very first load (to avoid overwriting)
    if (!didLoadData.current) return;

    const existingData =
      JSON.parse(localStorage.getItem("technicianFormData")) || {};

    const formData = {
      ...existingData,
      mobile,
      gender,
      date: date ? date.toISOString() : null,
      address,
      selectedCategory,
      selectedServices,
      expyears,
      certificateName,
      issuingOrganisation,
      issuingDate,
      certificateFile,
      govissuedid,
      govisFile,
      addressfile,
      profileFile,
      aboutme,
    };
    localStorage.setItem("technicianFormData", JSON.stringify(formData));
  }, [
    mobile,
    gender,
    date,
    address,
    selectedCategory,
    selectedServices,
    expyears,
    certificateName,
    issuingOrganisation,
    issuingDate,
    certificateFile,
    govissuedid,
    govisFile,
    addressfile,
    profileFile,
    aboutme,
  ]);

  // Certificate
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setCertificateFile({ file, preview: reader.result });
    };
    reader.readAsDataURL(file);

    // Clear the input after file selection (optional)
    e.target.value = null;
  };

  const handleDeleteImage = () => {
    setCertificateFile(null);
  };

  // Gov ID
  const handleGovFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setGovisFile({ file, preview: reader.result });
    };
    reader.readAsDataURL(file);

    e.target.value = null;
  };

  const handleGovDeleteImage = () => {
    setGovisFile(null);
  };

  // Proof of Address
  const handleProfFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setAddressFile({ file, preview: reader.result });
    };
    reader.readAsDataURL(file);

    e.target.value = null;
  };

  const handleProfDeleteImage = () => {
    setAddressFile(null);
  };

  // Profile Photo
  const handleProfileFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = () => {
      setProfileFile({ file, preview: reader.result });
    };
    reader.readAsDataURL(file);

    e.target.value = null;
  };

  const handleProfileDeleteImage = () => {
    setProfileFile(null);
  };

  useEffect(() => {
    const fetchServices = async () => {
      try {
        const snapshot = await get(ref(db, "categories"));
        if (snapshot.exists()) {
          const data = snapshot.val();
          let servicesList = [];
          Object.values(data).forEach((category) => {
            if (category.services) {
              Object.values(category.services).forEach((service) => {
                servicesList.push(service.name);
              });
            }
          });
          setServices(servicesList);
        }
      } catch (error) {
        console.error("Error fetching services:", error);
      }
    };
    fetchServices();
  }, []);

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const snapshot = await get(ref(db, "categories"));
        if (snapshot.exists()) {
          setCategories(snapshot.val());
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }

    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  const handleClose = () => {
    console.log("Modal is closing now 🛑");
    // Example: clear form data or localStorage
    localStorage.removeItem("technicianFormData");

    if (onClose) {
      onClose(); // Important: call the parent’s close handler
    }
  };

  const handlePlaceChanged = () => {
    if (autocomplete) {
      const place = autocomplete.getPlace();
      if (place?.formatted_address) {
        setAddress(place.formatted_address);
      }
    }
  };

  const handleServiceToggle = (serviceName) => {
    setSelectedServices((prevServices) => {
      const existingService = prevServices.find((s) => s.name === serviceName);

      if (existingService) {
        // Remove service if already selected
        return prevServices.filter((s) => s.name !== serviceName);
      } else {
        // Add service with a default price of 0
        return [...prevServices, { name: serviceName, price: 0 }];
      }
    });
  };

  const handleCategoryChange = (categoryName) => {
    setSelectedCategory(categoryName);
    setSelectedServices([]); // Reset selected services when changing category
  };

  const handleSignOut = async () => {
    const auth = getAuth();
    try {
      await signOut(auth);
      console.log("User signed out");
      Navigate("/"); // redirect to login page
    } catch (error) {
      console.error("Error signing out:", error);
    }
  };

  const saveDetails = async () => {
    setLoading(true);
    const userId = auth.currentUser.uid;

    try {
      let proofAddressUrl = "";
      let govIssuedIdUrl = "";
      let certificateUrl = "";
      let profileUrl = "";

      if (addressfile) {
        const proofAddressRef = storageRef(
          storage,
          `technicians/${userId}/proof_address`
        );
        await uploadBytes(proofAddressRef, addressfile.file);
        proofAddressUrl = await getDownloadURL(proofAddressRef);
      }

      if (govisFile) {
        const govIssuedIdRef = storageRef(
          storage,
          `technicians/${userId}/gov_issued_id`
        );
        await uploadBytes(govIssuedIdRef, govisFile.file);
        govIssuedIdUrl = await getDownloadURL(govIssuedIdRef);
      }

      if (certificateFile) {
        const certificateRef = storageRef(
          storage,
          `technicians/${userId}/certificate`
        );
        await uploadBytes(certificateRef, certificateFile.file);
        certificateUrl = await getDownloadURL(certificateRef);
      }

      if (profileFile) {
        const profileRef = storageRef(
          storage,
          `technicians/${userId}/profile_image`
        );
        await uploadBytes(profileRef, profileFile.file);
        profileUrl = await getDownloadURL(profileRef);
      }

      // Ensure selectedServices is stored with a default price (0)

      await set(ref(db, `technicians/${userId}`), {
        ...userData,
        services: selectedServices, // Store selected services
        expyears,
        certificateName,
        issuingOrganisation,
        certificateUrl,
        govissuedid,
        govIssuedIdUrl,
        proofAddressUrl,
        profileUrl,
        mobile,
        gender,
        date,
        address,
        selectedCategory,
        issuingDate,
        level: "elite",
        aboutme,
        rating: 5,
        bio: false,
        pricing: true,
      });
      const walletRef = ref(db, `wallets/${userId}`);
      await set(walletRef, {
        balance: 0,
        createdAt: Date.now(),
        transactions: {},
        lastUpdated: Date.now(),
      });
      localStorage.removeItem("technicianFormData");
      // Navigate to dashboard after successful submission
      navigate("/technician/dashboard");
    } catch (error) {
      console.error("Error saving details:", error);
      alert("Failed to save details. Please try again.");
      localStorage.removeItem("technicianFormData");
    }
    setLoading(false);
  };

  const { isLoaded, loadError } = useJsApiLoader({
    googleMapsApiKey,
    libraries,
  });

  if (loadError) {
    return null; // or show an error boundary
  }

  if (!isLoaded) {
    return null; // ⛔️ no loading indicator
  }

  if (!isOpen) return null;
  if (loading) return <Loader />;
  return (
    <>
      <div className='modal-overlay' onClick={handleClose}>
        <div
          className='modal-content'
          onClick={(e) => e.stopPropagation()} // Prevent closing on content click
        >
          <button className='modal-close' onClick={handleSignOut}>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              viewBox='0 0 24 24'
              width='32'
              height='32'
              fill='currentColor'
            >
              <path d='M10.5859 12L2.79297 4.20706L4.20718 2.79285L12.0001 10.5857L19.793 2.79285L21.2072 4.20706L13.4143 12L21.2072 19.7928L19.793 21.2071L12.0001 13.4142L4.20718 21.2071L2.79297 19.7928L10.5859 12Z'></path>
            </svg>
          </button>

          {active === "techtitledescription" && (
            <div className='jobtitledescription'>
              <div className='inputjobcnt'>
                <h1>What's your call line?</h1>
                <input
                  type='text'
                  name='mobile'
                  value={mobile}
                  onChange={(e) => setMobile(e.target.value)}
                  placeholder='080__________0'
                />
              </div>
              <div className='thespacee'></div>
              <div className='inputjobcnt'>
                <h1>What is your gender?</h1>
                <div className='inputjobcntselect'>
                  <div className='inputsecls'>
                    <input
                      type='text'
                      placeholder='What is your gender?'
                      value={gender}
                      onChange={(e) => {
                        setGender(e.target.value);
                        setShowGender(true);
                      }}
                    />
                  </div>
                  {showGender && (
                    <>
                      <div
                        className='invibg'
                        onClick={() => setShowGender(false)}
                      ></div>
                      <div className='searchinputcont'>
                        <div
                          className='serchsasitem'
                          onClick={() => {
                            setGender("male");
                            setShowGender(!showGender);
                          }}
                        >
                          <p>Male</p>
                        </div>
                        <div
                          className='serchsasitem'
                          onClick={() => {
                            setGender("female");
                            setShowGender(!showGender);
                          }}
                        >
                          <p>Female</p>
                        </div>
                        <div
                          className='serchsasitem'
                          onClick={() => {
                            setGender("other");
                            setShowGender(!showGender);
                          }}
                        >
                          <p>Other</p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className='thespacee'></div>
              <div className='inputjobcnt'>
                <h1>When were you born?</h1>
                <div
                  className='
                            '
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <DatePicker
                    selected={date}
                    onChange={(date) => setDate(date)}
                    dateFormat='MMMM d, yyyy'
                    placeholderText='Select date of birth'
                    maxDate={new Date()} // custom max date
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode='select'
                    isClearable
                    className='my-datepicker'
                  />
                </div>
              </div>
              <div className='thespacee'></div>
              <div className='thespacee'></div>
              {mobile.length > 0 && gender.length > 0 && date && (
                <div className='thebtnss'>
                  <button
                    className='cntbtn'
                    onClick={() => setActive("address")}
                  >
                    Continue
                  </button>
                  <button className='canbtn' onClick={handleSignOut}>
                    Cancel
                  </button>
                </div>
              )}
            </div>
          )}
          {active === "address" && (
            <div className='jobtitledescription'>
              <div className='inputjobcnt'>
                <h1>Tell us your address</h1>
                <Autocomplete
                  onLoad={(autocomplete) => setAutocomplete(autocomplete)}
                  onPlaceChanged={handlePlaceChanged}
                  options={{
                    componentRestrictions: { country: "NG" }, // Restrict to Nigeria
                  }}
                >
                  <input
                    type='text'
                    name='address'
                    placeholder='Enter your address'
                    id='address'
                    value={address}
                    onChange={(e) => setAddress(e.target.value)}
                    className='autocomplete-input'
                  />
                </Autocomplete>
              </div>
              <div className='thespacee'></div>
              <div className='thespacee'></div>
              <div className='thespacee'></div>
              {address.length > 0 && (
                <div className='thebtnss'>
                  <div className='cntnext'>
                    <button
                      className='canbtn'
                      onClick={() => setActive("techtitledescription")}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 24 24'
                        width='24'
                        height='24'
                        fill='#111'
                      >
                        <path d='M22.0003 13.0001L22.0004 11.0002L5.82845 11.0002L9.77817 7.05044L8.36396 5.63623L2 12.0002L8.36396 18.3642L9.77817 16.9499L5.8284 13.0002L22.0003 13.0001Z'></path>
                      </svg>
                    </button>
                    <button
                      className='cntbtn'
                      onClick={() => setActive("experience")}
                    >
                      Continue
                    </button>
                  </div>

                  <button className='canbtn' onClick={handleSignOut}>
                    Cancel
                  </button>
                </div>
              )}
            </div>
          )}
          {active === "experience" && (
            <div className='jobtitledescription'>
              <div className='inputjobcnt'>
                <h1>What Category does your task fall under?</h1>
                <div className='category-buttons'>
                  {Object.keys(categories).map((categoryName) => (
                    <button
                      key={categoryName}
                      onClick={() => handleCategoryChange(categoryName)}
                      className={`category-btn ${
                        selectedCategory === categoryName ? "catactive" : ""
                      }`}
                    >
                      {categoryName}
                    </button>
                  ))}
                </div>
              </div>
              <div className='thespacee'></div>
              <div className='dividar'></div>
              <div className='thespace'></div>
              {selectedCategory && categories[selectedCategory]?.services && (
                <div className='inputjobcnt'>
                  <h1 className='thealtinput'>What is the service type?</h1>
                  <p className='thewars'>
                    Note: you can select multiple services.
                  </p>
                  <div className='thespace'></div>
                  <div className='service-options'>
                    {Object.values(categories[selectedCategory].services).map(
                      (service) => {
                        const isSelected = selectedServices.some(
                          (s) => s.name === service.name
                        );

                        return (
                          <button
                            key={service.name}
                            type='button'
                            className={`category-btn service-item ${
                              isSelected ? "catselected" : ""
                            }`}
                            onClick={() => handleServiceToggle(service.name)}
                          >
                            {service.name}
                          </button>
                        );
                      }
                    )}
                  </div>
                </div>
              )}
              <div className='thespacee'></div>
              {/* Display Selected Services */}
              {/* <div className='selected-services'>
                {selectedServices.length > 0 ? (
                  <div className='selected-services-list'>
                    {selectedServices.map((service, index) => (
                      <div key={index} className='selected-service'>
                        <span>{service.name}</span>
                        <button
                          onClick={() => handleServiceToggle(service.name)}
                        >
                          <svg
                            xmlns='http://www.w3.org/2000/svg'
                            viewBox='0 0 24 24'
                            width='16'
                            height='16'
                            fill='currentColor'
                          >
                            <path d='M11.9997 10.5865L16.9495 5.63672L18.3637 7.05093L13.4139 12.0007L18.3637 16.9504L16.9495 18.3646L11.9997 13.4149L7.04996 18.3646L5.63574 16.9504L10.5855 12.0007L5.63574 7.05093L7.04996 5.63672L11.9997 10.5865Z'></path>
                          </svg>
                        </button>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p></p>
                )}
              </div> */}
              <div className='dividar'></div>
              <div className='thespace'></div>
              <div className='inputjobcnt'>
                <h1>Years of experience</h1>
                <input
                  type='number'
                  value={expyears}
                  onChange={(e) => setExpyears(e.target.value)}
                />
              </div>
              <div className='thespacee'></div>
              <div className='thespacee'></div>
              {selectedCategory.length > 0 &&
                selectedServices.length > 0 &&
                expyears.length > 0 && (
                  <div className='thebtnss'>
                    <div className='cntnext'>
                      <button
                        className='canbtn'
                        onClick={() => setActive("address")}
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          viewBox='0 0 24 24'
                          width='24'
                          height='24'
                          fill='#111'
                        >
                          <path d='M22.0003 13.0001L22.0004 11.0002L5.82845 11.0002L9.77817 7.05044L8.36396 5.63623L2 12.0002L8.36396 18.3642L9.77817 16.9499L5.8284 13.0002L22.0003 13.0001Z'></path>
                        </svg>
                      </button>
                      <button
                        className='cntbtn'
                        onClick={() => setActive("certification")}
                      >
                        Continue
                      </button>
                    </div>

                    <button className='canbtn' onClick={handleSignOut}>
                      Cancel
                    </button>
                  </div>
                )}
            </div>
          )}
          {active === "certification" && (
            <div className='jobtitledescription'>
              <div className='inputjobcnt'>
                <h1>Certification</h1>
                <input
                  type='text'
                  name='certificate'
                  value={certificateName}
                  onChange={(e) => setCertificateName(e.target.value)}
                  placeholder='Enter certificate name'
                />
              </div>
              <div className='thespacee'></div>
              <div className='inputjobcnt'>
                <h1>Issuing Organisation?</h1>
                <input
                  type='text'
                  name='issuing'
                  value={issuingOrganisation}
                  onChange={(e) => setIssuingOrganisation(e.target.value)}
                  placeholder='Enter Issuing organisation'
                />
              </div>
              <div className='thespacee'></div>
              <div className='inputjobcnt'>
                <h1>Issuing date</h1>
                <div
                  className='
                            '
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <DatePicker
                    selected={issuingDate}
                    onChange={(date) => setIssuingDate(date)}
                    dateFormat='MMMM d, yyyy'
                    placeholderText='Select date'
                    maxDate={new Date()} // custom max date
                    showMonthDropdown
                    showYearDropdown
                    dropdownMode='select'
                    isClearable
                    className='my-datepicker'
                  />
                </div>
              </div>
              <div className='thespacee'></div>
              <div className='inputjobcnt'>
                <h1>Upload certificate</h1>

                <div className='theimageinputcnt'>
                  <div className='custom-file-input'>
                    <input
                      type='file'
                      id='imaggeUpload'
                      name='image'
                      accept='.jpg, .jpeg, .png, .pdf'
                      onChange={handleFileChange}
                    />
                    <label htmlFor='imaggeUpload'>
                      <span className='upload-text'>+</span>
                    </label>
                  </div>

                  <div className='preview-container'>
                    {certificateFile ? (
                      <div className='preview-item'>
                        {certificateFile.file.type === "application/pdf" ? (
                          <embed
                            src={certificateFile.preview}
                            type='application/pdf'
                            height='300px' // 👈 Required: sets display size
                            className='previewimg'
                          />
                        ) : (
                          <img
                            src={certificateFile.preview}
                            alt='Preview'
                            className='previewimg'
                          />
                        )}
                        <button
                          onClick={handleDeleteImage}
                          className='imgdeleteicon'
                        >
                          ×
                        </button>
                      </div>
                    ) : (
                      <p>No file uploaded.</p>
                    )}
                  </div>
                </div>
              </div>
              <div className='thespacee'></div>
              <div className='thespacee'></div>
              {certificateName.length > 0 &&
                issuingOrganisation.length > 0 &&
                issuingDate &&
                certificateFile && (
                  <div className='thebtnss'>
                    <div className='cntnext'>
                      <button
                        className='canbtn'
                        onClick={() => setActive("experience")}
                      >
                        <svg
                          xmlns='http://www.w3.org/2000/svg'
                          viewBox='0 0 24 24'
                          width='24'
                          height='24'
                          fill='#111'
                        >
                          <path d='M22.0003 13.0001L22.0004 11.0002L5.82845 11.0002L9.77817 7.05044L8.36396 5.63623L2 12.0002L8.36396 18.3642L9.77817 16.9499L5.8284 13.0002L22.0003 13.0001Z'></path>
                        </svg>
                      </button>
                      <button
                        className='cntbtn'
                        onClick={() => setActive("government")}
                      >
                        Continue
                      </button>
                    </div>

                    <button className='canbtn' onClick={handleSignOut}>
                      Cancel
                    </button>
                  </div>
                )}
            </div>
          )}
          {active === "government" && (
            <div className='jobtitledescription'>
              <div className='inputjobcnt'>
                <h1>Government Issued ID</h1>
                <p className='thewars'>
                  Note: ID must be either NIN or Voter's card
                </p>
                <div className='inputjobcntselect'>
                  <div className='inputsecls'>
                    <input
                      type='text'
                      placeholder='Enter ID type?'
                      value={govissuedid}
                      onChange={(e) => {
                        setGovIssuedId(e.target.value);
                        setShowgovid(true);
                      }}
                    />
                  </div>
                  {showgovid && (
                    <>
                      <div
                        className='invibg'
                        onClick={() => setShowgovid(false)}
                      ></div>
                      <div className='searchinputcont'>
                        <div
                          className='serchsasitem'
                          onClick={() => {
                            setGovIssuedId("NIN");
                            setShowgovid(!showgovid);
                          }}
                        >
                          <p>NIN</p>
                        </div>
                        <div
                          className='serchsasitem'
                          onClick={() => {
                            setGovIssuedId("Voter's card");
                            setShowgovid(!showgovid);
                          }}
                        >
                          <p>Voter's Card</p>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>

              <div className='thespacee'></div>
              <div className='thespacee'></div>
              <div className='inputjobcnt'>
                <h1>Upload ID</h1>

                <div className='theimageinputcnt'>
                  <div className='custom-file-input'>
                    <input
                      type='file'
                      id='imageUpload'
                      name='image'
                      accept='.jpg, .png, .pdf'
                      onChange={handleGovFileChange}
                    />
                    <label htmlFor='imageUpload'>
                      <span className='upload-text'>+</span>
                    </label>
                  </div>

                  <div className='preview-container'>
                    {govisFile ? (
                      <div className='preview-item'>
                        {govisFile.file.type === "application/pdf" ? (
                          <embed
                            src={govisFile.preview}
                            type='application/pdf'
                            height='300px' // 👈 Required: sets display size
                            className='previewimg'
                          />
                        ) : (
                          <img
                            src={govisFile.preview}
                            alt='Preview'
                            className='previewimg'
                          />
                        )}
                        <button
                          onClick={handleGovDeleteImage}
                          className='imgdeleteicon'
                        >
                          ×
                        </button>
                      </div>
                    ) : (
                      <p>No file uploaded.</p>
                    )}
                  </div>
                </div>
              </div>
              <div className='thespacee'></div>
              <div className='thespacee'></div>
              <div className='inputjobcnt'>
                <h1>Upload Proof of Address</h1>

                <div className='theimageinputcnt'>
                  <div className='custom-file-input'>
                    <input
                      type='file'
                      id='imageeUpload'
                      name='proof'
                      accept='.jpg, .png, .pdf'
                      onChange={handleProfFileChange}
                    />
                    <label htmlFor='imageeUpload'>
                      <span className='upload-text'>+</span>
                    </label>
                  </div>

                  <div className='preview-container'>
                    {addressfile ? (
                      <div className='preview-item'>
                        {addressfile.file.type === "application/pdf" ? (
                          <embed
                            src={addressfile.preview}
                            type='application/pdf'
                            height='300px' // 👈 Required: sets display size
                            className='previewimg'
                          />
                        ) : (
                          <img
                            src={addressfile.preview}
                            alt='Preview'
                            className='previewimg'
                          />
                        )}
                        <button
                          onClick={handleProfDeleteImage}
                          className='imgdeleteicon'
                        >
                          ×
                        </button>
                      </div>
                    ) : (
                      <p>No file uploaded.</p>
                    )}
                  </div>
                </div>
              </div>
              <div className='thespacee'></div>
              <div className='thespacee'></div>
              {govissuedid.length > 0 && govisFile && addressfile && (
                <div className='thebtnss'>
                  <div className='cntnext'>
                    <button
                      className='canbtn'
                      onClick={() => setActive("certification")}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 24 24'
                        width='24'
                        height='24'
                        fill='#111'
                      >
                        <path d='M22.0003 13.0001L22.0004 11.0002L5.82845 11.0002L9.77817 7.05044L8.36396 5.63623L2 12.0002L8.36396 18.3642L9.77817 16.9499L5.8284 13.0002L22.0003 13.0001Z'></path>
                      </svg>
                    </button>
                    <button
                      className='cntbtn'
                      onClick={() => setActive("working")}
                    >
                      Continue
                    </button>
                  </div>

                  <button className='canbtn' onClick={handleSignOut}>
                    Cancel
                  </button>
                </div>
              )}
            </div>
          )}
          {active === "working" && (
            <div className='jobtitledescription'>
              <div className='inputjobcnt'>
                <h1>Upload your profile picture</h1>

                <div className='theimageinputcnt'>
                  <div className='custom-file-input'>
                    <input
                      type='file'
                      id='imageeeUpload'
                      name='profileimage'
                      accept='.jpg, .png'
                      onChange={handleProfileFileChange}
                    />
                    <label htmlFor='imageeeUpload'>
                      <span className='upload-text'>+</span>
                    </label>
                  </div>

                  <div className='preview-container'>
                    {profileFile ? (
                      <div className='preview-item'>
                        {profileFile.file.type === "application/pdf" ? (
                          <embed
                            src={profileFile.preview}
                            type='application/pdf'
                            height='300px' // 👈 Required: sets display size
                            className='previewimg'
                          />
                        ) : (
                          <img
                            src={profileFile.preview}
                            alt='Preview'
                            className='previewimg'
                          />
                        )}
                        <button
                          onClick={handleProfileDeleteImage}
                          className='imgdeleteicon'
                        >
                          ×
                        </button>
                      </div>
                    ) : (
                      <p>No file uploaded.</p>
                    )}
                  </div>
                </div>
              </div>
              <div className='thespacee'></div>
              <div className='thespacee'></div>
              <div className='inputjobcnt'>
                <h1>Tell us about you</h1>
                <input
                  type='text'
                  name='about'
                  value={aboutme}
                  onChange={(e) => setAboutme(e.target.value)}
                  placeholder='Tell us your experience and work'
                />
              </div>
              <div className='thespacee'></div>
              <div className='thespacee'></div>

              {profileFile && aboutme.length > 0 && (
                <div className='thebtnss'>
                  <div className='cntnext'>
                    <button
                      className='canbtn'
                      onClick={() => setActive("government")}
                    >
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        viewBox='0 0 24 24'
                        width='24'
                        height='24'
                        fill='#111'
                      >
                        <path d='M22.0003 13.0001L22.0004 11.0002L5.82845 11.0002L9.77817 7.05044L8.36396 5.63623L2 12.0002L8.36396 18.3642L9.77817 16.9499L5.8284 13.0002L22.0003 13.0001Z'></path>
                      </svg>
                    </button>
                    <button className='cntbtn' onClick={saveDetails}>
                      Submit
                    </button>
                  </div>

                  <button className='canbtn' onClick={onClose}>
                    Cancel
                  </button>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default TechnicianVeri;
